import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { 
  FiUser, 
  FiLink, 
  FiStar, 
  FiShare2, 
  FiCreditCard, 
  FiPlusSquare,
  FiChevronRight,
  FiX
} from "react-icons/fi";
import PaymentUtilities from "./PaymentUtilities";
import EsmBlockchain from "./EsmBlockchain";
import EsmInnovation from "./EsmInnovation";
import EsmConnection from "./EsmConnection";
import EsmExpansion from "./EsmExpansion";
import "./EsmImplementation.scss";
import logoEsm from "../../../images/Logo/logoESM.png";

const EsmImplementation = () => {
  const { t } = useTranslation();
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isBlockchainModalOpen, setIsBlockchainModalOpen] = useState(false);
  const [isInnovationModalOpen, setIsInnovationModalOpen] = useState(false);
  const [isConnectionModalOpen, setIsConnectionModalOpen] = useState(false);
  const [isExpansionModalOpen, setIsExpansionModalOpen] = useState(false);

  const ecoItems = [
    { id: 1, text: t("esm_implementation.item_blockchain"), icon: <FiLink /> },
    { id: 2, text: t("esm_implementation.item_creativity"), icon: <FiStar /> },
    { id: 3, text: t("esm_implementation.item_connection"), icon: <FiShare2 /> },
    { id: 4, text: t("esm_implementation.item_payment"), icon: <FiCreditCard /> },
    { id: 5, text: t("esm_implementation.item_expansion"), icon: <FiPlusSquare /> }
  ];

  return (
    <div className="esm-implementation-section">
      <h3 className="ei-title">{t("esm_implementation.title")}</h3>
      
      <div className="ei-pipeline-container">
        {/* Origin: ESM */}
        <div className="ei-origin">
          <div className="ei-logo-box">
            <img src={logoEsm} alt="ESM Logo" />
          </div>
          <div className="ei-label">{t("esm_implementation.smart_ecosystem")}</div>
        </div>

        <div className="ei-arrow">
          <FiChevronRight />
        </div>

        {/* Middle: Contributions */}
        <div className="ei-contributions">
          {ecoItems.map((item) => {
            return (
              <div 
                key={item.id} 
                className="ei-eco-card clickable"
                onClick={() => {
                  if (item.id === 1) setIsBlockchainModalOpen(true);
                  if (item.id === 2) setIsInnovationModalOpen(true);
                  if (item.id === 3) setIsConnectionModalOpen(true);
                  if (item.id === 4) setIsPaymentModalOpen(true);
                  if (item.id === 5) setIsExpansionModalOpen(true);
                }}
              >
                <div className="eco-icon">{item.icon}</div>
                <div className="eco-text">
                  {item.text.replace(/\n/g, " ")}
                </div>
              </div>
            );
          })}
        </div>

        <div className="ei-arrow">
          <FiChevronRight />
        </div>

        {/* Target: Patient */}
        <div className="ei-target">
          <div className="ei-patient-box">
            <div className="pt-icon-wrap">
              <FiUser />
            </div>
            <div className="pt-text">{t("esm_implementation.patient")}</div>
            <div className="pt-sub">{t("esm_implementation.beneficiary")}</div>
          </div>
        </div>
      </div>

      {/* Payment Utilities Modal */}
      {isPaymentModalOpen && (
        <div className="ei-modal-overlay" onClick={() => setIsPaymentModalOpen(false)}>
          <div className="ei-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ei-modal-close" onClick={() => setIsPaymentModalOpen(false)}>
              <FiX />
            </button>
            <div className="ei-modal-inner-scroll">
              <PaymentUtilities />
            </div>
          </div>
        </div>
      )}

      {/* Blockchain Diagram Modal */}
      {isBlockchainModalOpen && (
        <div className="ei-modal-overlay" onClick={() => setIsBlockchainModalOpen(false)}>
          <div className="ei-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ei-modal-close" onClick={() => setIsBlockchainModalOpen(false)}>
              <FiX />
            </button>
            <div className="ei-modal-inner-scroll">
              <EsmBlockchain />
            </div>
          </div>
        </div>
      )}
      {/* Innovation Diagram Modal */}
      {isInnovationModalOpen && (
        <div className="ei-modal-overlay" onClick={() => setIsInnovationModalOpen(false)}>
          <div className="ei-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ei-modal-close" onClick={() => setIsInnovationModalOpen(false)}>
              <FiX />
            </button>
            <div className="ei-modal-inner-scroll">
              <EsmInnovation />
            </div>
          </div>
        </div>
      )}

      {/* Connection Diagram Modal */}
      {isConnectionModalOpen && (
        <div className="ei-modal-overlay" onClick={() => setIsConnectionModalOpen(false)}>
          <div className="ei-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ei-modal-close" onClick={() => setIsConnectionModalOpen(false)}>
              <FiX />
            </button>
            <div className="ei-modal-inner-scroll">
              <EsmConnection />
            </div>
          </div>
        </div>
      )}

      {/* Expansion Diagram Modal */}
      {isExpansionModalOpen && (
        <div className="ei-modal-overlay" onClick={() => setIsExpansionModalOpen(false)}>
          <div className="ei-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ei-modal-close" onClick={() => setIsExpansionModalOpen(false)}>
              <FiX />
            </button>
            <div className="ei-modal-inner-scroll">
              <EsmExpansion />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EsmImplementation;
